import { render, staticRenderFns } from "./TradeRequestResponseList.vue?vue&type=template&id=839bfc46"
import script from "./TradeRequestResponseList.vue?vue&type=script&lang=js"
export * from "./TradeRequestResponseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports